import { Routes } from "@angular/router";
import { LoginComponent } from "./login/login.component";
import { LayoutComponent } from "./layout/layout.component";
import { UpdatePriceComponent } from "./update-price/update-price.component";
import { AddCustomerDialogComponent } from "./dialog/add-customer.dialog/add-customer.dialog.component";
import { ResetPasswordComponent } from "./reset-password/reset-password.component";
import { AuthGuard } from "./auth.guard";

export const routes: Routes = [
  {
    path: "",
    redirectTo: "/login",
    pathMatch: "full",
  },
  {
    path: "login",
    component: LoginComponent,
    data: { icon: "login", text: "Login" }
  },
  { path: 'reset', component: ResetPasswordComponent },
  {
    path: "",
    component: LayoutComponent, // Parent layout
    canActivateChild: [AuthGuard],
    children: [
      {
        path: "updatePrice",
        component: UpdatePriceComponent,
        data: { icon: "price_change", text: "Update Price" }
      },
      {
        path: "user",
        component: AddCustomerDialogComponent,
        data: { icon: "person_add", text: "Create User" }
      },{
        path: "recordPayment",
        loadComponent: () => import('./record-payment/record-payment.component').then(m => m.RecordPaymentComponent),
        data: { icon: "payment", text: "Record Payment" }
      },{
        path: 'download-receipt',
        loadComponent: () => import('./download-receipt/download-receipt.component').then(m => m.DownloadReceiptComponent),
        data: { icon: "download", text: "Download Receipt" }
      },
    ],
  },
];
